import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';

@Component({
  selector: 'lowy-submit-upload',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <span class="link" (click)="modal.close()"><i class="material-icons">keyboard_backspace</i>cancel</span>
      <div class="headline">Are You Sure?</div>
      <div class="subheading">
        Are you sure you would like to upload the below data? Once uploaded, it will appear in the database for all researchers to view.
      </div>
      <ul>
        <li *ngFor="let item of items">{{item.fileName}}</li>
      </ul>
      <mat-form-field>
        <textarea [(ngModel)]="uploadComments" matInput placeholder="Upload Comments" matTextareaAutosize></textarea>
      </mat-form-field>
      <div class="row">
        <div class="col-2">
          <button mat-button class="lowy-btn-std" (click)="submit()">add</button>
        </div>
      </div>
    </div>
  </lowy-modal>
  `
})
export class SubmitUploadComponent {
  public uploadComments: string;
  public items: any[];

  @ViewChild('modal') modal: ModalComponent;

  @Output() send: EventEmitter<string>;

  constructor() {
    this.send = new EventEmitter();
  }

  public open(items: any[]) {
    this.items = items;
    this.modal.open();
  }

  public submit() {
    this.send.emit(this.uploadComments);
    this.uploadComments = null;
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/uploader/modals/submit-modal.component.ts